import { ActivatedRouteSnapshot } from '@angular/router';
import { submittedDocDetailTokenizer } from '@data-access/documents/token';
import type { Submission } from '@submissions/next/models';

export const workspaceDocumentDetailResolver = (
  route: ActivatedRouteSnapshot,
) => {
  const _docDetailsSignalStore = submittedDocDetailTokenizer();
  const _documentID = route.paramMap.get('documentId') ?? '';
  const _submission = route.parent?.data['submission'] as Submission;

  _docDetailsSignalStore.loadDocumentTypes({ workspaceId: _submission.id });

  _docDetailsSignalStore.loadAttributeTypes({
    entityType: _submission.entity_type,
  });

  _docDetailsSignalStore.loadDocument(_documentID);

  return true;
};
